import $ from 'jquery';

export default {

	init() {

		// Open menu
		$('#hamburger').click(function(e) {

			$('#header-mobile').slideToggle(function(e) {

				if($(this).is(':visible')) {
					$(".main-menu a").first().focus();
				}

			});

		});

		// Close menu
		$('#close-btn').click(function(e) {

			$('#header-mobile').slideUp(function(e) {
				$('#hamburger').focus();
			});

		});

	}

};
